import axios from "axios";
import MerchantEmployeeLayout from "../../layout/MerchantEmployeeLayout";
import { useCallback, useContext, useEffect, useState } from "react";
import { SubscriptionInfo, UserInfo } from "../../../context";
import moment from "moment";
import { Button, Col, Modal, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { SyncOutlined } from "@ant-design/icons";
import EditAdditionalServiceStatus from "./EditAdditionalServiceStatus";

const MerchantEmployeeHouseKeeping = () => {
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const navigate = useNavigate();
  const [selectedData, setSelectedData] = useState(null);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);

  const [occupiedList, setOccupiedList] = useState({
    data: [],
    ready: false,
  });
  const [vacantDirtyList, setVacantDirtyList] = useState({
    data: [],
    ready: false,
  });
  const [vacantCleanList, setVacantCleanList] = useState({
    data: [],
    ready: false,
  });
  const [vacantReadyList, setVacantReadyList] = useState({
    data: [],
    ready: false,
  });

  const getAddtionalServiceList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant/additional-service-list", { params })
      .then((response) => {
        const data = response.data;
        const active = data.filter((data) => parseInt(data.status) === 1);
        if (active.length > 0) {
          const occupied = active.filter(
            (data) =>
              data.service_status_abbreviation === "O" &&
              data.service_type !== "one-time"
          );
          setOccupiedList({ data: occupied, ready: true });

          const vacantdirty = active.filter(
            (data) =>
              data.service_status_abbreviation === "VD" &&
              data.service_type !== "one-time"
          );
          setVacantDirtyList({ data: vacantdirty, ready: true });

          const vacantclean = active.filter(
            (data) =>
              data.service_status_abbreviation === "VC" &&
              data.service_type !== "one-time"
          );
          setVacantCleanList({ data: vacantclean, ready: true });

          const vacantready = active.filter(
            (data) =>
              data.service_status_abbreviation === "VR" &&
              data.service_type !== "one-time"
          );
          setVacantReadyList({ data: vacantready, ready: true });
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    getAddtionalServiceList();
  }, [getAddtionalServiceList]);

  return (
    <MerchantEmployeeLayout>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }} />
          <Button
            type="default"
            icon={<SyncOutlined />}
            onClick={() => getAddtionalServiceList()}
          >
            Refresh
          </Button>
        </div>
      </div>

      <Row gutter={[8, 8]}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <div
            style={{
              border: "1px solid #e5e5e5",
              borderRadius: 10,
              display: "flex",
              flexDirection: "column",
              padding: 5,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor:
                    //   data.service_status_abbreviation === "VR"
                    //     ? "green"
                    //     : data.service_status_abbreviation === "VC"
                    //     ? "orange"
                    //     : data.service_status_abbreviation === "VD"
                    //     ? "red"
                    //     :
                    "gray",
                  marginRight: 5,
                  borderRadius: 5,
                }}
              />
              <Typography style={{ fontSize: 16, fontWeight: "bold" }}>
                Occupied
              </Typography>
            </div>
            {occupiedList.ready &&
              occupiedList.data.length > 0 &&
              occupiedList.data.map((data, index) => (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    margin: 2,
                  }}
                  key={index}
                >
                  <div style={{ flexGrow: 1 }}>
                    <Typography>{data.service}</Typography>
                  </div>
                  {/* <div>
                      <Button size="small">Edit</Button>
                    </div> */}
                </div>
              ))}
          </div>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <div
            style={{
              border: "1px solid #e5e5e5",
              borderRadius: 10,
              display: "flex",
              flexDirection: "column",
              padding: 5,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: "red",
                  marginRight: 5,
                  borderRadius: 5,
                }}
              />
              <Typography style={{ fontSize: 16, fontWeight: "bold" }}>
                Vacant & Dirty
              </Typography>
            </div>
            {vacantDirtyList.ready &&
              vacantDirtyList.data.length > 0 &&
              vacantDirtyList.data.map((data, index) => (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    margin: 2,
                  }}
                  key={index}
                >
                  <div style={{ flexGrow: 1 }}>
                    <Typography>{data.service}</Typography>
                  </div>
                  <div>
                    <Button
                      size="small"
                      onClick={() => {
                        setSelectedData(data);
                        setOpenEditDrawer(true);
                      }}
                    >
                      Update
                    </Button>
                  </div>
                </div>
              ))}
          </div>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <div
            style={{
              border: "1px solid #e5e5e5",
              borderRadius: 10,
              display: "flex",
              flexDirection: "column",
              padding: 5,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: "orange",
                  marginRight: 5,
                  borderRadius: 5,
                }}
              />
              <Typography style={{ fontSize: 16, fontWeight: "bold" }}>
                Vacant & Clean
              </Typography>
            </div>
            {vacantCleanList.ready &&
              vacantCleanList.data.length > 0 &&
              vacantCleanList.data.map((data, index) => (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    margin: 2,
                  }}
                  key={index}
                >
                  <div style={{ flexGrow: 1 }}>
                    <Typography>{data.service}</Typography>
                  </div>
                  <div>
                    <Button
                      size="small"
                      onClick={() => {
                        setSelectedData(data);
                        setOpenEditDrawer(true);
                      }}
                    >
                      Update
                    </Button>
                  </div>
                </div>
              ))}
          </div>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <div
            style={{
              border: "1px solid #e5e5e5",
              borderRadius: 10,
              display: "flex",
              flexDirection: "column",
              padding: 5,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: "green",
                  marginRight: 5,
                  borderRadius: 5,
                }}
              />
              <Typography style={{ fontSize: 16, fontWeight: "bold" }}>
                Vacant & Ready
              </Typography>
            </div>
            {vacantReadyList.ready &&
              vacantReadyList.data.length > 0 &&
              vacantReadyList.data.map((data, index) => (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    margin: 2,
                  }}
                  key={index}
                >
                  <div style={{ flexGrow: 1 }}>
                    <Typography>{data.service}</Typography>
                  </div>
                  {/* <div>
                      <Button size="small">Edit</Button>
                    </div> */}
                </div>
              ))}
          </div>
        </Col>
      </Row>

      {openEditDrawer && (
        <EditAdditionalServiceStatus
          open={openEditDrawer}
          close={() => setOpenEditDrawer(false)}
          selectedData={selectedData}
          getAddtionalServiceList={() => getAddtionalServiceList()}
        />
      )}

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeHouseKeeping;
